<template>
  <el-form-item
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
    :class="[!labelShow ? 'lable-hidden' : '']"
  >
    <el-time-picker
      ref="timepicker"
      v-model.trim="innerValue"
      v-bind="{ ...$attrs }"
      :class="['date-picker-icon', iconTemp ? 'date-close' : '']"
      autocomplete="off"
      :clearable="false"
      :picker-options="pickerOptions"
      @mouseover.native="setDateIcon"
      @mouseleave.native="iconTemp = false"
      @change="(value) => changeSetMode(value)"
      @focus="focusInput"
    />
    <template #error="{ error }">
      <el-tooltip class="item" effect="dark" :content="error" placement="left">
        <div
          class="el-form-item__error"
          :class="{ error_box: $attrs['error'] == 'true' }"
        >
          {{ error }}
        </div>
      </el-tooltip>
    </template>
  </el-form-item>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabTimePicker',
    mixins: [mixins],
    data() {
      return {
        iconTemp: false,
        pickerOptions: {
          selectableRange: '00:00:00 - 23:59:59',
        },
      }
    },
    watch: {
      innerValue: {
        handler(val) {
          // if (val && val == '00:00') {
          //   this.innerValue = null
          // }
          if (val) {
            if (this.valueFormatSss) {
              val = this.formatTimeDefault(val, this.$const.dateFormatHHMMSSSSS)
            }
            this.setModel(val)
          }
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {},
    methods: {
      focusInput() {
        let str = null
        if (this.valueFormatSss) {
          str = this.$const.dateFormatHHMMSSSSS
        } else {
          str = '00:00'
        }
        if (this.endDateProp) {
          let endDate = this.$baseLodash.get(this.form.model, this.endDateProp)
          if (!this.$baseLodash.isEmpty(endDate) && endDate != str) {
            this.pickerOptions.selectableRange = '00:00:00 - ' + endDate + ':00'
          }
        }
        if (this.startDateProp) {
          let startDate = this.$baseLodash.get(
            this.form.model,
            this.startDateProp
          )

          if (!this.$baseLodash.isEmpty(startDate) && startDate != str) {
            this.pickerOptions.selectableRange =
              startDate + ':00' + ' - 23:59:00'
          }
        }
        this.$forceUpdate()
      },
      setDateIcon() {
        if (this.innerValue == '' || this.innerValue == null) {
          return false
        }
        this.iconTemp = true
      },
      changeSetMode(value) {
        if (this.valueFormatSss) {
          value = this.formatTimeDefault(value, this.$const.dateFormatHHMMSSSSS)
        }
        this.setModel(value)
        this.focusInput()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .lable-hidden {
    ::v-deep {
      .el-form-item__label {
        display: none;
        width: 0px !important;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
  }
  .date-picker-icon {
    width: 60px !important;

    ::v-deep {
      .el-input__prefix,
      .el-input__suffix {
        display: none !important;
      }
      .el-input__inner {
        padding: 0 !important;
        text-align: center !important;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .el-icon-date {
      display: none;
    }
  }
</style>
